<template>
  <div>
    <vs-popup fullscreen :title="$t('AddReceiver')" :active.sync="showModal">
      <!-- <div class="vx-row"> -->
      <div>
        <form>
          <div class="vx-row mb-6">
            <div class="vx-col lg:w-2/3 w-full">
              <label class="vs-select--label">{{ $t("Receiver") }}</label>
              <treeselect
                name="Receiver"
                :multiple="false"
                :placeholder="$t('SearchReceiver')"
                :async="true"
                :load-options="loadOptions"
                class="search-input py-1"
                ref="Receiver"
                @select="onReceiverSelected"
              />
            </div>
            <div class="vx-row vx-col lg:w-1/3 w-full">
              <vs-button
                color="primary"
                type="filled"
                icon-pack="feather"
                icon="icon-plus"
                class="add-btn mx-12"
                @click.prevent="assignReceiver(2)"
                >{{ $t("Receiver") }}</vs-button
              >
              <vs-button
                color="primary"
                type="filled"
                icon-pack="feather"
                icon="icon-plus"
                class="add-btn"
                @click.prevent="assignReceiver(3)"
                >{{ $t("ReceiverCC") }}</vs-button
              >
            </div>
          </div>
        </form>
        <div class="vx-row">
          <div class="vx-col w-full my-2">
            <vs-table :data="ReceiverList" class="custom-tbl">
              <template slot="thead">
                <th style="width: 5%">#</th>
                <th style="width: 30%">{{ $t("Name") }}</th>
                <th style="width: 20%">{{ $t("Email") }}</th>
                <th style="width: 20%">{{ $t("Status") }}</th>
                <th style="width: 20%">{{ $t("Action") }}</th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="i" v-for="(index, i) in data">
                  <vs-td>
                    {{ i + 1 }}
                  </vs-td>
                  <vs-td>
                    {{ index.fullName }}
                  </vs-td>
                  <vs-td>
                    {{ index.emailAddress }}
                  </vs-td>
                  <vs-td>
                    <span v-if="index.notificationType == 2">{{
                      $t("Receiver")
                    }}</span>
                    <span v-else-if="index.notificationType == 3">{{
                      $t("ReceiverCC")
                    }}</span>
                    <span v-else>----</span>
                  </vs-td>
                  <vs-td>
                    <vs-button
                      radius
                      color="danger"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-x"
                      @click.prevent="unassignReceiver(i)"
                      class="d-inline"
                    ></vs-button>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
      <vs-button
        color="primary"
        type="filled"
        icon-pack="feather"
        class="px-12"
        style="position: absolute; bottom: 4%; left: 4%"
        @click.prevent="submitForm()"
        >{{ $t("Save") }}</vs-button
      >
    </vs-popup>
  </div>
</template>
<style lang="scss">
.add-btn {
  margin-top: 1.5rem;
}
</style>

<script>
import { mapActions } from "vuex";
import DataGrid from "@/components/datagrid/DataGrid";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "",
  props: {
    show: { default: false },
    currentTemplateId: "",
  },
  data() {
    return {
      ReceiverList: [],
      model: {},
      seachModel: {},
      searchQueryNew: "",
      searchQueryOld: "",
      currentReceiver: "",
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("finish");
      },
    },
  },
  methods: {
    ...mapActions({
      searchReceiver: "notification/fetchSearch",
      updateReceiverAndCc: "notification/updateReceiverAndCc",
      fetchReceiverById: "notification/fetchReceiverById",
    }),
    loadOptions({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.searchReceiver(searchQuery).then((r) => {
              const options = [];
              r.data.forEach(function (element) {
                options.push({
                  id: element.id,
                  label: element.fullName,
                  emailAddress: element.emailAddress,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    unassignReceiver(i) {
      this.ReceiverList.splice(i, 1);
    },
    onReceiverSelected(data) {
      this.currentReceiver = data;
    },
    assignReceiver(type) {
      this.ReceiverList.push({
        receiverId: this.currentReceiver.id,
        fullName: this.currentReceiver.label,
        emailAddress: this.currentReceiver.emailAddress,
        notificationType: type,
      });
    },

    submitForm() {
      this.model.receiverSettings = this.ReceiverList.map(
        ({ receiverId, notificationType }) => ({ receiverId, notificationType })
      );
      this.model.id = this.currentTemplateId;
      this.updateReceiverAndCc(this.model).then(() => {
        this.$emit("finish");
      });
    },
  },
  watch: {
    show() {
      this.fetchReceiverById(this.currentTemplateId)
        .then((r) => {
          this.ReceiverList = r;
        })
        .catch(() => {
          this.$refs.Receiver.clear();
        });
    },
  },
  components: {
    Treeselect,
    DataGrid,
  },
};
</script>
